import axiosInstance from './axios';

export const productService = {
  getProducts: async (params = {}) => {
    const response = await axiosInstance.get('/products', { params });
    return response.data;
  },

  getProduct: async (id) => {
    const response = await axiosInstance.get(`/products/${id}`);
    return response.data;
  },

  createProduct: async (productData) => {
    const response = await axiosInstance.post('/products', productData);
    return response.data;
  },

  updateProduct: async (id, productData) => {
    const response = await axiosInstance.put(`/products/${id}`, productData);
    return response.data;
  },

  deleteProduct: async (id) => {
    const response = await axiosInstance.delete(`/products/${id}`);
    return response.data;
  },

  // Apply the same changes (category, brand, badges, status) to many products.
  bulkUpdateProducts: async (ids, updates) => {
    const response = await axiosInstance.post('/products/bulk-update', { ids, updates });
    return response.data;
  },

  getProductAnalytics: async (id) => {
    const response = await axiosInstance.get(`/products/${id}/analytics`);
    return response.data;
  },
};
